loggedInUserWishList = [];
loggedInUserViewedList = [];

function getLocalList(obj) {
  const list = localStorage.getItem(obj);
  if (list) return list.split(",");
  return [];
}

async function updateCounter() {
  let items = [];
  if (__st.cid) {
    items = loggedInUserWishList;
  } else {
    items = getLocalList("wishlistObj");
  }
  if (items.length > 0) {
    document.getElementById("wishlistCounter").style.display = "flex";
    document.getElementsByClassName("wishlist-header-counter")[0].innerHTML =
      items.length;
  } else {
    document.getElementById("wishlistCounter").style.display = "none";
  }
}

customElements.get("wishlist-counter") ||
  customElements.define(
    "wishlist-counter",
    class extends HTMLElement {
      constructor() {
        super();
        if (__st.cid) {
          this.mergeWishlists();
        } else {
          updateCounter();
        }
      }

      async mergeWishlists() {
        const fetchWishList = async () => {
          const response = await fetch(
            `https://api.givadiva.co/v2/omnichannel/getWishlist?user_shopify_id=${__st.cid}`
          );
          const data = await response.json();
          return data.data;
        };
        const fetchViewedList = async () => {
          const response = await fetch(
            `https://api.givadiva.co/v2/omnichannel/viewedProducts?user_shopify_id=${__st.cid}`
          );
          const data = await response.json();
          return data.data;
        };
        const fetchLists = async () => {
          [loggedInUserWishList, loggedInUserViewedList] = await Promise.all([
            fetchWishList(),
            fetchViewedList(),
          ]);
        };
        await fetchLists();
        const locallist = getLocalList("wishlistObj");
        const userList = loggedInUserWishList;
        const difference = locallist.filter((x) => !userList.includes(x));
        if (difference.length === 0) {
          updateCounter();
        } else {
          const mergedList = userList.concat(difference);
          for (let itemHandle of difference) {
            await fetch("https://api.givadiva.co/v2/omnichannel/addToWishlist", {
              method: "POST",
              body: JSON.stringify({
                user_shopify_id: `${__st.cid}`,
                handle: itemHandle,
              }),
              headers: { "Content-Type": "application/json" },
            }).then((e) => {
              console.log(e);
            });
          }
          localStorage.setItem("wishlistObj", mergedList);
          loggedInUserWishList = mergedList;
          updateCounter();
          if (window.location.href === "https://www.giva.co/pages/wishlist") {
            window.location.reload();
          }
        }
      }
    }
  );

customElements.get("manage-wishlist") ||
  customElements.define(
    "manage-wishlist",
    class extends HTMLElement {
      constructor() {
        super();
        this.btn =
          this.querySelector(".heart") || this.querySelector(".product-heart");
        this.btn.addEventListener(
          "click",
          this.manageWishlist.bind(this, this.btn)
        );
        this.preFillWishList(this.btn);
      }

      changeTooltip(btn) {
        const subBtn = btn.querySelectorAll(".heart-fill")[0];
        if (
          Array.from(btn.classList).includes("product-heart") &&
          subBtn.style.display === "flex"
        ) {
          btn.setAttribute("data-tooltip", "Remove from wishlist");
        } else {
          btn.setAttribute("data-tooltip", "Add to wishlist");
        }
      }

      async preFillWishList(btn) {
        window.onload = () => {
          setTimeout(() => {
            if (__st.cid) {
              const items = loggedInUserWishList;
              if (items.includes(btn.id)) {
                this.swapWishlistBtn(btn, "heart-no-fill", "heart-fill");
              }
            } else {
              if (getLocalList("wishlistObj").includes(btn.id)) {
                this.swapWishlistBtn(btn, "heart-no-fill", "heart-fill");
              }
            }
            this.changeTooltip(this.btn);
          }, 1000);
        };
      }

      async manageWishlist(btn) {
        const itemHandle = btn.id;
        if (
          btn.getElementsByClassName("heart-fill")[0].style.display === "flex"
        ) {
          this.removeFromWishlist(itemHandle, btn);
        } else {
          this.moveToWishlist(itemHandle, btn);
        }
      }

      async moveToWishlist(itemHandle, btn) {
        if (__st.cid) {
          await fetch("https://api.givadiva.co/v2/omnichannel/addToWishlist", {
            method: "POST",
            body: JSON.stringify({
              user_shopify_id: `${__st.cid}`,
              handle: itemHandle,
            }),
            headers: { "Content-Type": "application/json" },
          }).then((e) => {
            console.log(e);
            if (btn !== "") {
              if (
                btn.getElementsByClassName("heart-fill")[0].style.display ===
                "flex"
              ) {
                this.swapWishlistBtn(btn, "heart-fill", "heart-no-fill");
              } else {
                this.swapWishlistBtn(btn, "heart-no-fill", "heart-fill");
              }
              this.changeTooltip(btn);
            }
            loggedInUserWishList.push(itemHandle);
            updateCounter();
          });
          await fetch("https://api.giva.co/storeWishlistInContlo", {
            method: "POST",
            body: JSON.stringify({
              email: customerDetails.email,
              phone: customerDetails.phone,
              product_id: btn.getAttribute("data-productId"),
              variant_id: btn.getAttribute("data-variantId"),
              first_name: customerDetails.first_name,
              last_name: customerDetails.last_name,
            }),
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((s) => s.json())
            .then((r) => {
              console.log(r);
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          let wishlist = getLocalList("wishlistObj");
          if (wishlist.indexOf(itemHandle) === -1) {
            wishlist.push(itemHandle);
            localStorage.setItem("wishlistObj", wishlist);
            updateCounter();
            if (btn !== "") {
              this.swapWishlistBtn(btn, "heart-no-fill", "heart-fill");
              this.changeTooltip(btn);
            }
          }
        }
      }

      async removeFromWishlist(itemHandle, btn) {
        if (__st.cid) {
          await fetch("https://api.givadiva.co/v2/omnichannel/removeFromWishlist", {
            method: "DELETE",
            body: JSON.stringify({
              user_shopify_id: `${__st.cid}`,
              handle: itemHandle,
            }),
            headers: { "Content-Type": "application/json" },
          }).then((e) => {
            console.log(e);
            if (btn !== "") {
              if (
                btn.getElementsByClassName("heart-fill")[0].style.display ===
                "flex"
              ) {
                this.swapWishlistBtn(btn, "heart-fill", "heart-no-fill");
              } else {
                this.swapWishlistBtn(btn, "heart-no-fill", "heart-fill");
              }
              this.changeTooltip(btn);
            }
            let index = loggedInUserWishList.indexOf(itemHandle);
            if (index !== -1) {
              loggedInUserWishList.splice(index, 1);
            }
            updateCounter();
          });
        } else {
          let wishlist = getLocalList("wishlistObj");
          const index = wishlist.indexOf(itemHandle);
          wishlist.splice(index, 1);
          localStorage.setItem("wishlistObj", wishlist);
          updateCounter();
          if (btn !== "") {
            this.swapWishlistBtn(btn, "heart-fill", "heart-no-fill");
            this.changeTooltip(btn);
          }
        }
      }

      swapWishlistBtn(btn, from, to) {
        btn.getElementsByClassName(from)[0].style.display = "none";
        btn.getElementsByClassName(to)[0].style.display = "flex";
      }
    }
  );

customElements.get("wish-view-list") ||
  customElements.define(
    "wish-view-list",
    class extends HTMLElement {
      constructor() {
        super();
        if (__st.cid) {
          this.mergeRecentlyViewedLists();
        }
        this.getWishList();
        document
          .getElementById("recently-viewed")
          .addEventListener("click", this.getRecentlyViewedList.bind(this));
        document
          .getElementById("my-wishlist")
          .addEventListener("click", this.getWishList.bind(this));
        this.querySelector("#share-wishlist").addEventListener(
          "click",
          this.shareWishlist.bind(this)
        );
        document
          .getElementById("dialog-button-1")
          .addEventListener("click", async () => {
            await this.deleteWishItem(
              document.getElementById("delete-dialog").classList[0]
            );
            document.getElementById("delete-dialog").style.display = "none";
          });
        document
          .getElementById("dialog-button-2")
          .addEventListener(
            "click",
            () =>
              (document.getElementById("delete-dialog").style.display = "none")
          );
      }

      async mergeRecentlyViewedLists() {
        window.onload = () => {
          setTimeout(async () => {
            const locallist = getLocalList("recentlyViewedObj");
            const userList = loggedInUserViewedList;
            const difference = locallist.filter((x) => !userList.includes(x));
            if (difference.length > 0) {
              const mergedList = userList.concat(difference);
              for (let itemHandle of difference) {
                await fetch("https://api.givadiva.co/v2/omnichannel/productView", {
                  method: "POST",
                  body: JSON.stringify({
                    user_shopify_id: `${__st.cid}`,
                    handle: itemHandle,
                  }),
                  headers: { "Content-Type": "application/json" },
                }).then((e) => {
                  console.log(e);
                });
              }
              localStorage.setItem("recentlyViewedObj", mergedList);
              loggedInUserViewedList = mergedList;
            }
          }, 1000);
        };
      }

      swapActiveOption(from, to) {
        document.getElementById(from).classList.remove("wish-active-header");
        document.getElementById(to).classList.add("wish-active-header");
      }

      loadList(from, to) {
        document.getElementById("reco-loader").style.display = "flex";
        document.getElementById(`${from}-content`).style.display = "none";
        document.getElementById(`${to}-content`).style.display = "block";
        document.getElementById("wish-items").style.display = "none";
        document.getElementsByClassName("empty-wishlist")[0].style.display =
          "none";
        document.getElementById("recently-viewed-items").style.display = "none";
        document.getElementsByClassName(
          "empty-recently-viewed-list"
        )[0].style.display = "none";
        document.getElementsByClassName(
          "section-collection-list"
        )[0].style.display = "none";
      }

      delay(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      }

      async getWishList() {
        this.swapActiveOption("recently-viewed", "my-wishlist");
        this.loadList("recently-viewed", "wishlist");
        document.getElementsByClassName("wish-items-list")[0].innerHTML = "";
        const element = document.getElementsByClassName("wish-items-list")[0];
        let items = [];
        if (loggedInUserWishList.length === 0) {
          await this.delay(1000);
        }
        if (__st.cid) {
          items = loggedInUserWishList;
        } else {
          items = getLocalList("wishlistObj");
        }
        if (items.length > 0) {
          Promise.allSettled(
            items.map((p) =>
              fetch(`/products/${p}?view=wishlist`)
                .then((r) => r.text())
                .then((res) => {
                  const text = res;
                  const parser = new DOMParser();
                  const htmlDocument = parser.parseFromString(
                    text,
                    "text/html"
                  );
                  const productCard =
                    htmlDocument.documentElement.querySelector(
                      ".wishlist-template-card"
                    );
                  if (productCard) {
                    return productCard.innerHTML;
                  } else {
                    return null;
                  }
                })
            )
          ).then((cards) => {
            const finalProds = cards.filter((s) => s.value != null);
            if (finalProds.length > 0) {
              finalProds.reverse();
              document.getElementById("wish-items").style.display = "flex";
              document.getElementById("reco-loader").style.display = "none";
              document.getElementById("wish-items").style.display = "flex";
              finalProds.forEach((prod, index) => {
                const finalHtml = `<li class="grid__item scroll-trigger animate--slide-in" style="--animation-order: ${
                  index + 1
                };">${prod.value}</li>`;
                element.innerHTML += finalHtml;
              });
              this.delBtn = this.querySelectorAll(".delete-wishItem");
              this.delBtn.forEach((btn) => {
                btn.addEventListener(
                  "click",
                  this.deleteWishItemPopUp.bind(this, btn.parentNode.id)
                );
              });
            } else {
              this.showEmptyList("wishlist");
            }
          });
        } else {
          this.showEmptyList("wishlist");
        }
      }

      showEmptyList(type) {
        if (type == "wishlist") {
          document.getElementsByClassName("empty-wishlist")[0].style.display =
            "flex";
          document.getElementsByClassName(
            "section-collection-list"
          )[0].style.display = "block";
          document.getElementById("reco-loader").style.display = "none";
        } else {
          document.getElementsByClassName(
            "empty-recently-viewed-list"
          )[0].style.display = "flex";
          document.getElementsByClassName(
            "section-collection-list"
          )[0].style.display = "block";
          document.getElementById("reco-loader").style.display = "none";
        }
      }

      deleteWishItemPopUp(itemHandle) {
        document.getElementById("delete-dialog").style.display = "flex";
        document
          .getElementById("delete-dialog")
          .setAttribute("class", itemHandle);
      }

      async deleteWishItem(itemHandle) {
        if (__st.cid) {
          await fetch("https://api.givadiva.co/v2/omnichannel/removeFromWishlist", {
            method: "DELETE",
            body: JSON.stringify({
              user_shopify_id: `${__st.cid}`,
              handle: itemHandle,
            }),
            headers: { "Content-Type": "application/json" },
          }).then(async (e) => {
            console.log(e);
            let index = loggedInUserWishList.indexOf(itemHandle);
            if (index !== -1) {
              loggedInUserWishList.splice(index, 1);
            }
            await this.deleteLocalWishItem(itemHandle);
          });
        } else {
          await this.deleteLocalWishItem(itemHandle);
        }
      }

      async deleteLocalWishItem(itemHandle) {
        let wishlist = getLocalList("wishlistObj");
        const index = wishlist.indexOf(itemHandle);
        if (index > -1) {
          wishlist.splice(index, 1);
          localStorage.setItem("wishlistObj", wishlist);
        }
        await this.getWishList();
        updateCounter();
      }

      async getRecentlyViewedList() {
        this.swapActiveOption("my-wishlist", "recently-viewed");
        this.loadList("wishlist", "recently-viewed");
        const element = document.getElementsByClassName(
          "recently-viewed-items-list"
        )[0];
        element.innerHTML = "";
        let items = [];
        if (__st.cid) {
          items = loggedInUserViewedList;
        } else {
          items = getLocalList("recentlyViewedObj");
        }
        if (items.length > 0) {
          Promise.allSettled(
            items.map((p) =>
              fetch(`/products/${p}?view=card`)
                .then((r) => r.text())
                .then((res) => {
                  const text = res;
                  const parser = new DOMParser();
                  const htmlDocument = parser.parseFromString(
                    text,
                    "text/html"
                  );
                  const productCard =
                    htmlDocument.documentElement.querySelector(
                      ".template-card"
                    );
                  if (productCard) {
                    return productCard.innerHTML;
                  } else {
                    return null;
                  }
                })
            )
          ).then((cards) => {
            const finalProds = cards.filter((s) => s.value != null);
            if (finalProds.length > 0) {
              document.getElementById("reco-loader").style.display = "none";
              document.getElementById("recently-viewed-items").style.display =
                "flex";
              finalProds.forEach((prod, index) => {
                const finalHtml = `<li class="grid__item scroll-trigger animate--slide-in" style="--animation-order: ${
                  index + 1
                };">${prod.value}</li>`;
                element.innerHTML += finalHtml;
              });
            } else {
              this.showEmptyList("recentList");
            }
          });
        } else {
          this.showEmptyList("recentList");
        }
      }

      async shareWishlist() {
        if (__st.cid) {
          const url = `https://www.giva.co/pages/view-wishlist?user_id=${__st.cid}`;
          navigator.share({
            url: url,
            title: "View Wishlist",
          });
        } else {
          document.getElementById("login-dialog").style.display = "flex";
          document
            .getElementById("dialog-close")
            .addEventListener(
              "click",
              () =>
                (document.getElementById("login-dialog").style.display = "none")
            );
          document
            .getElementById("forgot-password")
            .addEventListener("click", () => {
              document.getElementById("main-recover").style.display = "block";
              document.getElementById("main-login-content").style.display =
                "none";
            });
          document
            .getElementById("cancel-reset")
            .addEventListener("click", () => {
              document.getElementById("main-recover").style.display = "none";
              document.getElementById("main-login-content").style.display =
                "block";
            });
        }
      }
    }
  );
